import React from 'react';
import {View} from 'MWC';
import tpl from '../templates/cashback';
import widgetsHelper from 'utils/getWidget.helper';
import Model from '../models/form.m';
import queryParams from '../queries/form.m.q';
import {apiback} from '../../../../../config';

export default class extends View {
    templates = {
        [this.uiStates.INITIAL]: <div />,
        [this.uiStates.INTERACTIVE]: tpl,
        [this.uiStates.ERROR]: tpl,
        [this.uiStates.STANDBY]: tpl
    };

    template = tpl;

    constructor(props) {
        super(props);

        this.state = {
            ui: this.uiStates.INITIAL,
            where_by: ['path'],
            search_by: [location.pathname],
            widgets: [],
            model: new Model(),
            activeScreen: 'form'
        };

        this.query = queryParams;
        this.sliderRef = React.createRef();
        this._initMethods();
        this.widgetsHelper = widgetsHelper;
        return this;
    }

    componentWillMount() {
        window.location.pathname = '/services/become-partner';
    }

    componentWillReady(resolve) {
        this.widgetsHelper.getWidgets.call(this);
        resolve();
    }

    _initMethods() {
        this.onBlurHandle = this.onBlurHandle.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.setPhone = this.setPhone.bind(this);
        this._run = this._run.bind(this);
        this.sendForm = this.sendForm.bind(this);
        this.changeFilesUrl = this.changeFilesUrl.bind(this);
        this.filterSlidesByEnvironment = this.filterSlidesByEnvironment.bind(this);
    }

    sendForm = async () => {
        this.setState({activeScreen: 'loader'});
        const model = this.getModel();
        const data = {
            conv_data: {
                phone: model.fields.phone.value
                    .split('')
                    .filter(el => el !== ' ')
                    .join(''),
                name: model.fields.name.value,
                email: model.fields.email.value,
                product: model.fields.product.value,
                company: model.fields.company.value,
                info: model.fields.info.value
            },
            hash: 'D531DFS13FDFG321'
        };
        await this.query.sendForm(data);
        const activeScreen = this.query.activeScreen;
        this.setState({activeScreen});
    };

    onBlurHandle = name => {
        this.changeFirstInput(name);
    };

    changeFirstInput(name) {
        const model = this.getModel();
        model.changeFirst(name);
        model.validate();
        this.setState({model});
    }

    filterSlidesByEnvironment(slides) {
        if (slides) {
            if (window.location.href.includes('a-bank.com.ua')) {
                return slides.filter(slide => slide.prod === true);
            } else {
                return slides.filter(slide => slide.release === true);
            }
        }
    }

    setPhone(event) {
        const {value} = event.target;
        if (!value.length) {
            const data = {
                name: 'phone',
                value: '+380'
            };
            this._run(data);
        }
    }

    _run(data) {
        const model = this.getModel();
        model.run({name: data.name, value: data.value});
        this.setState({model});
    }

    handleChange(event) {
        const data = {
            name: event.target.name,
            value: event.target.value
        };

        this._run(data);
    }

    changeFilesUrl(url) {
        if (url) {
            if (url.includes('front-assets.a-bank')) {
                return url;
            } else {
                return apiback('API_PAGES') + url.slice(7);
            }
        }
    }
}
